import {
  IFormLead,
  IFormLeadCreatePayload,
  IFormLeadStatus,
  ILeadConsultant
} from '../../pages/Dashboard/FormLeads/models'
import apiService from '../Api'

interface IList {
  draw: number
  start: number
  length: number
  order: {
    column: number
    dir: string
  }[]
  search: {
    value: string
  }
  status?: IFormLeadStatus
  format: string[]
  course: string
  consultant: string
  period: {
    from: string
    to: string
  }
}

interface IGetQuantities {
  search: string
  status?: IFormLeadStatus
  format: string[]
  course: string
  consultant: string
  period: {
    from: string
    to: string
  }
}

export class FormLeadService {
  async list(params: IList): Promise<{ data: IFormLead[]; recordsFiltered: number }> {
    const queryParams = new URLSearchParams()
    queryParams.append('draw', params.draw.toString())
    queryParams.append('start', params.start.toString())
    queryParams.append('length', params.length.toString())
    queryParams.append('order[0][column]', params.order[0].column.toString())
    queryParams.append('order[0][dir]', params.order[0].dir)
    queryParams.append('search[value]', params.search.value)
    queryParams.append('course', params.course)
    queryParams.append('consultant', params.consultant)
    queryParams.append('period[from]', params.period.from)
    queryParams.append('period[to]', params.period.to)

    params.format.forEach((format, index) => {
      queryParams.append(`format[${index}]`, format)
    })

    if (params.status) {
      queryParams.append('status', params.status)
    }

    return apiService.get('/form-leads', { params: queryParams }).then((response) => response.data)
  }

  async create(data: IFormLeadCreatePayload): Promise<IFormLead> {
    return apiService.post('/form-leads', data).then((response) => response.data)
  }

  /** Consultores do registro manual: os marcados para aparecer em formulários. */
  async getConsultants(): Promise<ILeadConsultant[]> {
    return apiService.get('/form-leads/consultants').then((response) => response.data)
  }

  /** Mesma lista pública que o formulário antigo do site consultava para avisar da blacklist. */
  async getBlacklistedEmails(): Promise<string[]> {
    return apiService.get('/website/black-listed-emails').then((response) => response.data.emails ?? [])
  }

  async update(id: number, data: IFormLead): Promise<void> {
    return apiService.put(`/form-leads/${id}`, data)
  }

  async updateStatus(id: number, status: string): Promise<void> {
    return apiService.put(`/form-leads/${id}/set-status`, { status })
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/form-leads/${id}`)
  }

  async deleteMultiple(ids: number[]): Promise<void> {
    return apiService.delete('/form-leads', { data: { ids } })
  }

  async getAreas(format: string): Promise<string[]> {
    return apiService.get('/form-leads/areas', { params: { format } }).then((response) => response.data)
  }

  async getCourses(area: string): Promise<string[]> {
    return apiService.get('/form-leads/courses', { params: { area } }).then((response) => response.data)
  }

  async getSellers(): Promise<string[]> {
    return apiService.get('/form-leads/sellers').then((response) => response.data)
  }

  async getQuantities(filters: IGetQuantities): Promise<{
    total: number
    Qualificado: number
    Desqualificado: number
    'Sem Contato': number
  }> {
    const queryParams = new URLSearchParams()
    queryParams.append('search', filters.search)
    queryParams.append('course', filters.course)
    queryParams.append('consultant', filters.consultant)
    queryParams.append('period[from]', filters.period.from)
    queryParams.append('period[to]', filters.period.to)

    filters.format.forEach((format, index) => {
      queryParams.append(`format[${index}]`, format)
    })

    if (filters.status) {
      queryParams.append('status', filters.status)
    }

    return apiService.get('/form-leads/quantities', { params: queryParams }).then((response) => response.data)
  }
}
